import React from "react";

import Pagination from "./Pagination";

export default function PaginationBar({
      from,
      to,
      total,
      pageCount,
      page,
      goToPage
  }) {
    return (
        <div className="flex justify-between items-center bg-white p-4 border-t border-gray-300">
            <p className="text-sm text-gray-700">
                Showing <span className="font-medium">{ from }</span> to <span className="font-medium">{ to }</span> of <span className="font-medium">{ total }</span> results
            </p>

            <Pagination
                spacingClass=""
                className="text-center"
                pageCount={ pageCount }
                page={ page }
                goToPage={ goToPage }
            />
        </div>
    );
};
